<label
  class="text-muted-color flex items-center gap-1.5 text-sm whitespace-nowrap"
  [for]="inputId()"
>
  <p-checkbox [inputId]="inputId()" [binary]="true" [(ngModel)]="checked" />
  {{ labelKey() | transloco }}
</label>
